import { APP_PAGES } from '../../../routes/constants';

// Gates the hard trial-expired redirect in useTrialGate — when true, an expired
// trial forces navigation to /billing on every non-exempt route.
export const IS_BILLING_GATE_ENABLED = true;

// Gates the credits balance UI (sidebar card, Flows header chip/popover, buy
// modal) and every credits query. Off by default: debits are off in prod and
// no wallet has been granted yet, so without this flag every user would see
// a "no credits" state that reads as an error.
export const IS_CREDITS_BALANCE_UI_ENABLED = false;

// Prefix-matched against location.pathname — a team route covers both
// /team and /team/:teamId.
export const BILLING_GATE_EXEMPT_PATH_PREFIXES: ReadonlySet<string> = new Set([
  APP_PAGES.BILLING,
  APP_PAGES.ACCOUNT,
  APP_PAGES.SUPPORT,
  APP_PAGES.TEAM,
]);

export const BILLING_PAGE_MEMBERS_FETCH_LIMIT = 100;

// No sales-email constant exists yet (checked auth/constants.ts and
// Support.tsx) — the marketing pricing page is the product-approved fallback.
export const ENTERPRISE_CONTACT_URL = 'https://www.thisandthat.chat/pricing';

export const TEAM_PLAN_FEATURE_KEYS: readonly string[] = [
  'billing.plans.team.features.fullProduct',
  'billing.plans.team.features.channels',
  'billing.plans.team.features.sharedTasks',
  'billing.plans.team.features.sharedContacts',
  'billing.plans.team.features.crossTeamWorkflows',
  'billing.plans.team.features.mcpServers',
];

export const ENTERPRISE_PLAN_FEATURE_KEYS: readonly string[] = [
  'billing.plans.enterprise.features.everythingAbove',
  'billing.plans.enterprise.features.sso',
  'billing.plans.enterprise.features.scim',
  'billing.plans.enterprise.features.customTerms',
];
